export default __webpack_public_path__ + "static/media/email-activation.3ebed38b.png";